/**
 * Clase de fallo del dashboard de pagos. Solo la CLASE viaja al dominio: el
 * `detail` del back no tiene campo acá a propósito, así ninguna pantalla puede
 * terminar mostrándolo (CLAUDE.md §Security: sin detalles del backend en la UI).
 *
 *  - `forbidden`   403: sin autoridad sobre los datos de pagos.
 *  - `badRequest`  400: periodo inválido (custom sin fechas, `from > to`, formato).
 *  - `unavailable` cualquier otra cosa: 5xx, 404 (back sin el endpoint), red, tiempo agotado.
 */
export type PaymentsDashboardErrorKind = 'forbidden' | 'badRequest' | 'unavailable';

export class PaymentsDashboardError extends Error {
  constructor(readonly kind: PaymentsDashboardErrorKind) {
    super(`payments-dashboard:${kind}`);
    this.name = 'PaymentsDashboardError';
  }
}
